package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Niue Flag (20x15dp)
 *
 * - ISO Alpha-2: NU
 * - ISO Alpha-3: NIU
 * - ISO Numeric: 570
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Niue: ImageVector by lazy {
    ImageVector.Builder(
        name = "Niue:NU:NIU:570:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 10f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(-1.414f, 9.456f)
                lineTo(2.55f, 10.373f)
                lineTo(11.001f, 5.704f)
                lineTo(11.895f, 5.181f)
                lineTo(19.922f, 0.983f)
                lineTo(21.824f, -0.342f)
                lineTo(17.474f, -0.743f)
                lineTo(10.461f, 3.213f)
                lineTo(5.392f, 5.704f)
                lineTo(-1.414f, 9.456f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.066f, 10.012f)
                lineTo(1.069f, 10.712f)
                lineTo(21.031f, -0.509f)
                horizontalLineTo(18.034f)
                lineTo(-1.066f, 10.012f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(21.482f, 9.207f)
                lineTo(21.639f, 10.151f)
                lineTo(17.45f, 10.373f)
                lineTo(10.696f, 6.417f)
                lineTo(10.059f, 6.635f)
                lineTo(-2.55f, 0.257f)
                lineTo(2.656f, -0.745f)
                lineTo(9.616f, 3.099f)
                lineTo(15.061f, 5.73f)
                lineTo(21.482f, 9.207f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(21.496f, 9.773f)
                lineTo(19.362f, 10.473f)
                lineTo(10.862f, 5.669f)
                lineTo(8.342f, 5.132f)
                lineTo(-2.037f, -0.336f)
                horizontalLineTo(0.96f)
                lineTo(11.333f, 5.003f)
                lineTo(14.088f, 5.646f)
                lineTo(21.496f, 9.773f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(8.243f, -0.781f)
                verticalLineTo(-1.563f)
                horizontalLineTo(7.462f)
                verticalLineTo(-0.781f)
                horizontalLineTo(8.243f)
                close()
                moveTo(8.243f, 2.969f)
                verticalLineTo(3.75f)
                horizontalLineTo(9.024f)
                verticalLineTo(2.969f)
                horizontalLineTo(8.243f)
                close()
                moveTo(-0.781f, 2.969f)
                verticalLineTo(2.188f)
                horizontalLineTo(-1.563f)
                verticalLineTo(2.969f)
                horizontalLineTo(-0.781f)
                close()
                moveTo(-0.781f, 7.031f)
                horizontalLineTo(-1.563f)
                verticalLineTo(7.813f)
                horizontalLineTo(-0.781f)
                verticalLineTo(7.031f)
                close()
                moveTo(8.243f, 7.031f)
                horizontalLineTo(9.024f)
                verticalLineTo(6.25f)
                horizontalLineTo(8.243f)
                verticalLineTo(7.031f)
                close()
                moveTo(8.243f, 12.031f)
                horizontalLineTo(7.462f)
                verticalLineTo(12.813f)
                horizontalLineTo(8.243f)
                verticalLineTo(12.031f)
                close()
                moveTo(11.799f, 12.031f)
                verticalLineTo(12.813f)
                horizontalLineTo(12.58f)
                verticalLineTo(12.031f)
                horizontalLineTo(11.799f)
                close()
                moveTo(11.799f, 7.031f)
                verticalLineTo(6.25f)
                horizontalLineTo(11.017f)
                verticalLineTo(7.031f)
                horizontalLineTo(11.799f)
                close()
                moveTo(20.781f, 7.031f)
                verticalLineTo(7.813f)
                horizontalLineTo(21.563f)
                verticalLineTo(7.031f)
                horizontalLineTo(20.781f)
                close()
                moveTo(20.781f, 2.969f)
                horizontalLineTo(21.563f)
                verticalLineTo(2.188f)
                horizontalLineTo(20.781f)
                verticalLineTo(2.969f)
                close()
                moveTo(11.799f, 2.969f)
                horizontalLineTo(11.017f)
                verticalLineTo(3.75f)
                horizontalLineTo(11.799f)
                verticalLineTo(2.969f)
                close()
                moveTo(11.799f, -0.781f)
                horizontalLineTo(12.58f)
                verticalLineTo(-1.563f)
                horizontalLineTo(11.799f)
                verticalLineTo(-0.781f)
                close()
                moveTo(10.236f, 2.969f)
                verticalLineTo(3.75f)
                horizontalLineTo(11.017f)
                verticalLineTo(2.969f)
                horizontalLineTo(10.236f)
                close()
                moveTo(10.236f, 0.781f)
                horizontalLineTo(11.017f)
                verticalLineTo(0f)
                horizontalLineTo(10.236f)
                verticalLineTo(0.781f)
                close()
                moveTo(9.806f, 0.781f)
                verticalLineTo(0f)
                horizontalLineTo(9.024f)
                verticalLineTo(0.781f)
                horizontalLineTo(9.806f)
                close()
                moveTo(9.806f, 2.969f)
                horizontalLineTo(9.024f)
                verticalLineTo(3.75f)
                horizontalLineTo(9.806f)
                verticalLineTo(2.969f)
                close()
                moveTo(10.236f, 4.531f)
                horizontalLineTo(11.017f)
                verticalLineTo(3.75f)
                horizontalLineTo(10.236f)
                verticalLineTo(4.531f)
                close()
                moveTo(9.806f, 4.531f)
                verticalLineTo(3.75f)
                horizontalLineTo(9.024f)
                verticalLineTo(4.531f)
                horizontalLineTo(9.806f)
                close()
                moveTo(10.236f, 5.469f)
                verticalLineTo(6.25f)
                horizontalLineTo(11.017f)
                verticalLineTo(5.469f)
                horizontalLineTo(10.236f)
                close()
                moveTo(9.806f, 5.469f)
                horizontalLineTo(9.024f)
                verticalLineTo(6.25f)
                horizontalLineTo(9.806f)
                verticalLineTo(5.469f)
                close()
                moveTo(8.243f, 4.531f)
                horizontalLineTo(9.024f)
                verticalLineTo(3.75f)
                horizontalLineTo(8.243f)
                verticalLineTo(4.531f)
                close()
                moveTo(0.781f, 4.531f)
                verticalLineTo(3.75f)
                horizontalLineTo(0f)
                verticalLineTo(4.531f)
                horizontalLineTo(0.781f)
                close()
                moveTo(0.781f, 5.469f)
                horizontalLineTo(0f)
                verticalLineTo(6.25f)
                horizontalLineTo(0.781f)
                verticalLineTo(5.469f)
                close()
                moveTo(8.243f, 5.469f)
                verticalLineTo(6.25f)
                horizontalLineTo(9.024f)
                verticalLineTo(5.469f)
                horizontalLineTo(8.243f)
                close()
                moveTo(9.806f, 7.031f)
                verticalLineTo(6.25f)
                horizontalLineTo(9.024f)
                verticalLineTo(7.031f)
                horizontalLineTo(9.806f)
                close()
                moveTo(9.806f, 10.469f)
                horizontalLineTo(9.024f)
                verticalLineTo(11.25f)
                horizontalLineTo(9.806f)
                verticalLineTo(10.469f)
                close()
                moveTo(10.236f, 10.469f)
                verticalLineTo(11.25f)
                horizontalLineTo(11.017f)
                verticalLineTo(10.469f)
                horizontalLineTo(10.236f)
                close()
                moveTo(10.236f, 7.031f)
                horizontalLineTo(11.017f)
                verticalLineTo(6.25f)
                horizontalLineTo(10.236f)
                verticalLineTo(7.031f)
                close()
                moveTo(11.799f, 4.531f)
                verticalLineTo(3.75f)
                horizontalLineTo(11.017f)
                verticalLineTo(4.531f)
                horizontalLineTo(11.799f)
                close()
                moveTo(11.799f, 5.469f)
                horizontalLineTo(11.017f)
                verticalLineTo(6.25f)
                horizontalLineTo(11.799f)
                verticalLineTo(5.469f)
                close()
                moveTo(19.219f, 4.531f)
                horizontalLineTo(20f)
                verticalLineTo(3.75f)
                horizontalLineTo(19.219f)
                verticalLineTo(4.531f)
                close()
                moveTo(19.219f, 5.469f)
                verticalLineTo(6.25f)
                horizontalLineTo(20f)
                verticalLineTo(5.469f)
                horizontalLineTo(19.219f)
                close()
                moveTo(8.243f, 0f)
                horizontalLineTo(9.024f)
                verticalLineTo(-1.563f)
                horizontalLineTo(8.243f)
                verticalLineTo(0f)
                close()
                moveTo(9.024f, 0f)
                verticalLineTo(-0.781f)
                horizontalLineTo(7.462f)
                verticalLineTo(0f)
                horizontalLineTo(9.024f)
                close()
                moveTo(9.024f, 2.969f)
                verticalLineTo(0f)
                horizontalLineTo(7.462f)
                verticalLineTo(2.969f)
                horizontalLineTo(9.024f)
                close()
                moveTo(0f, 3.75f)
                horizontalLineTo(8.243f)
                verticalLineTo(2.188f)
                horizontalLineTo(0f)
                verticalLineTo(3.75f)
                close()
                moveTo(-0.781f, 3.75f)
                horizontalLineTo(0f)
                verticalLineTo(2.188f)
                horizontalLineTo(-0.781f)
                verticalLineTo(3.75f)
                close()
                moveTo(0f, 3.75f)
                verticalLineTo(2.969f)
                horizontalLineTo(-1.563f)
                verticalLineTo(3.75f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 6.25f)
                verticalLineTo(3.75f)
                horizontalLineTo(-1.563f)
                verticalLineTo(6.25f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 7.031f)
                verticalLineTo(6.25f)
                horizontalLineTo(-1.563f)
                verticalLineTo(7.031f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 6.25f)
                horizontalLineTo(-0.781f)
                verticalLineTo(7.813f)
                horizontalLineTo(0f)
                verticalLineTo(6.25f)
                close()
                moveTo(8.243f, 6.25f)
                horizontalLineTo(0f)
                verticalLineTo(7.813f)
                horizontalLineTo(8.243f)
                verticalLineTo(6.25f)
                close()
                moveTo(9.024f, 11.25f)
                verticalLineTo(7.031f)
                horizontalLineTo(7.462f)
                verticalLineTo(11.25f)
                horizontalLineTo(9.024f)
                close()
                moveTo(9.024f, 12.031f)
                verticalLineTo(11.25f)
                horizontalLineTo(7.462f)
                verticalLineTo(12.031f)
                horizontalLineTo(9.024f)
                close()
                moveTo(9.024f, 11.25f)
                horizontalLineTo(8.243f)
                verticalLineTo(12.813f)
                horizontalLineTo(9.024f)
                verticalLineTo(11.25f)
                close()
                moveTo(11.017f, 11.25f)
                horizontalLineTo(9.024f)
                verticalLineTo(12.813f)
                horizontalLineTo(11.017f)
                verticalLineTo(11.25f)
                close()
                moveTo(11.799f, 11.25f)
                horizontalLineTo(11.017f)
                verticalLineTo(12.813f)
                horizontalLineTo(11.799f)
                verticalLineTo(11.25f)
                close()
                moveTo(11.017f, 11.25f)
                verticalLineTo(12.031f)
                horizontalLineTo(12.58f)
                verticalLineTo(11.25f)
                horizontalLineTo(11.017f)
                close()
                moveTo(11.017f, 7.031f)
                verticalLineTo(11.25f)
                horizontalLineTo(12.58f)
                verticalLineTo(7.031f)
                horizontalLineTo(11.017f)
                close()
                moveTo(20f, 6.25f)
                horizontalLineTo(11.799f)
                verticalLineTo(7.813f)
                horizontalLineTo(20f)
                verticalLineTo(6.25f)
                close()
                moveTo(20.781f, 6.25f)
                horizontalLineTo(20f)
                verticalLineTo(7.813f)
                horizontalLineTo(20.781f)
                verticalLineTo(6.25f)
                close()
                moveTo(20f, 6.25f)
                verticalLineTo(7.031f)
                horizontalLineTo(21.563f)
                verticalLineTo(6.25f)
                horizontalLineTo(20f)
                close()
                moveTo(20f, 3.75f)
                verticalLineTo(6.25f)
                horizontalLineTo(21.563f)
                verticalLineTo(3.75f)
                horizontalLineTo(20f)
                close()
                moveTo(20f, 2.969f)
                verticalLineTo(3.75f)
                horizontalLineTo(21.563f)
                verticalLineTo(2.969f)
                horizontalLineTo(20f)
                close()
                moveTo(20f, 3.75f)
                horizontalLineTo(20.781f)
                verticalLineTo(2.188f)
                horizontalLineTo(20f)
                verticalLineTo(3.75f)
                close()
                moveTo(11.799f, 3.75f)
                horizontalLineTo(20f)
                verticalLineTo(2.188f)
                horizontalLineTo(11.799f)
                verticalLineTo(3.75f)
                close()
                moveTo(11.017f, 0f)
                verticalLineTo(2.969f)
                horizontalLineTo(12.58f)
                verticalLineTo(0f)
                horizontalLineTo(11.017f)
                close()
                moveTo(11.017f, -0.781f)
                verticalLineTo(0f)
                horizontalLineTo(12.58f)
                verticalLineTo(-0.781f)
                horizontalLineTo(11.017f)
                close()
                moveTo(11.017f, 0f)
                horizontalLineTo(11.799f)
                verticalLineTo(-1.563f)
                horizontalLineTo(11.017f)
                verticalLineTo(0f)
                close()
                moveTo(9.024f, 0f)
                horizontalLineTo(11.017f)
                verticalLineTo(-1.563f)
                horizontalLineTo(9.024f)
                verticalLineTo(0f)
                close()
                moveTo(11.017f, 2.969f)
                verticalLineTo(0.781f)
                horizontalLineTo(9.455f)
                verticalLineTo(2.969f)
                horizontalLineTo(11.017f)
                close()
                moveTo(10.236f, 0f)
                horizontalLineTo(9.806f)
                verticalLineTo(1.563f)
                horizontalLineTo(10.236f)
                verticalLineTo(0f)
                close()
                moveTo(9.024f, 0.781f)
                verticalLineTo(2.969f)
                horizontalLineTo(10.587f)
                verticalLineTo(0.781f)
                horizontalLineTo(9.024f)
                close()
                moveTo(9.806f, 3.75f)
                horizontalLineTo(10.236f)
                verticalLineTo(2.188f)
                horizontalLineTo(9.806f)
                verticalLineTo(3.75f)
                close()
                moveTo(10.236f, 3.75f)
                horizontalLineTo(9.806f)
                verticalLineTo(5.313f)
                horizontalLineTo(10.236f)
                verticalLineTo(3.75f)
                close()
                moveTo(11.017f, 5.469f)
                verticalLineTo(4.531f)
                horizontalLineTo(9.455f)
                verticalLineTo(5.469f)
                horizontalLineTo(11.017f)
                close()
                moveTo(9.806f, 6.25f)
                horizontalLineTo(10.236f)
                verticalLineTo(4.688f)
                horizontalLineTo(9.806f)
                verticalLineTo(6.25f)
                close()
                moveTo(9.024f, 4.531f)
                verticalLineTo(5.469f)
                horizontalLineTo(10.587f)
                verticalLineTo(4.531f)
                horizontalLineTo(9.024f)
                close()
                moveTo(8.243f, 3.75f)
                horizontalLineTo(0.781f)
                verticalLineTo(5.313f)
                horizontalLineTo(8.243f)
                verticalLineTo(3.75f)
                close()
                moveTo(0f, 4.531f)
                verticalLineTo(5.469f)
                horizontalLineTo(1.563f)
                verticalLineTo(4.531f)
                horizontalLineTo(0f)
                close()
                moveTo(0.781f, 6.25f)
                horizontalLineTo(8.243f)
                verticalLineTo(4.688f)
                horizontalLineTo(0.781f)
                verticalLineTo(6.25f)
                close()
                moveTo(9.024f, 5.469f)
                verticalLineTo(4.531f)
                horizontalLineTo(7.462f)
                verticalLineTo(5.469f)
                horizontalLineTo(9.024f)
                close()
                moveTo(9.024f, 7.031f)
                verticalLineTo(10.469f)
                horizontalLineTo(10.587f)
                verticalLineTo(7.031f)
                horizontalLineTo(9.024f)
                close()
                moveTo(9.806f, 11.25f)
                horizontalLineTo(10.236f)
                verticalLineTo(9.688f)
                horizontalLineTo(9.806f)
                verticalLineTo(11.25f)
                close()
                moveTo(11.017f, 10.469f)
                verticalLineTo(7.031f)
                horizontalLineTo(9.455f)
                verticalLineTo(10.469f)
                horizontalLineTo(11.017f)
                close()
                moveTo(10.236f, 6.25f)
                horizontalLineTo(9.806f)
                verticalLineTo(7.813f)
                horizontalLineTo(10.236f)
                verticalLineTo(6.25f)
                close()
                moveTo(11.017f, 4.531f)
                verticalLineTo(5.469f)
                horizontalLineTo(12.58f)
                verticalLineTo(4.531f)
                horizontalLineTo(11.017f)
                close()
                moveTo(19.219f, 3.75f)
                horizontalLineTo(11.799f)
                verticalLineTo(5.313f)
                horizontalLineTo(19.219f)
                verticalLineTo(3.75f)
                close()
                moveTo(20f, 5.469f)
                verticalLineTo(4.531f)
                horizontalLineTo(18.438f)
                verticalLineTo(5.469f)
                horizontalLineTo(20f)
                close()
                moveTo(11.799f, 6.25f)
                horizontalLineTo(19.219f)
                verticalLineTo(4.688f)
                horizontalLineTo(11.799f)
                verticalLineTo(6.25f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.058f, -0.833f)
                horizontalLineTo(8.942f)
                verticalLineTo(3.75f)
                horizontalLineTo(0f)
                verticalLineTo(6.25f)
                horizontalLineTo(8.942f)
                verticalLineTo(12.083f)
                horizontalLineTo(11.058f)
                verticalLineTo(6.25f)
                horizontalLineTo(21.25f)
                verticalLineTo(3.75f)
                horizontalLineTo(11.058f)
                verticalLineTo(-0.833f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.031f, 6.625f)
                curveTo(10.981f, 6.625f, 11.75f, 5.855f, 11.75f, 4.906f)
                curveTo(11.75f, 3.957f, 10.981f, 3.188f, 10.031f, 3.188f)
                curveTo(9.082f, 3.188f, 8.313f, 3.957f, 8.313f, 4.906f)
                curveTo(8.313f, 5.855f, 9.082f, 6.625f, 10.031f, 6.625f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.063f, 5.432f)
                lineTo(9.251f, 5.997f)
                lineTo(9.538f, 5.051f)
                lineTo(8.75f, 4.454f)
                lineTo(9.738f, 4.433f)
                lineTo(10.063f, 3.5f)
                lineTo(10.387f, 4.433f)
                lineTo(11.375f, 4.454f)
                lineTo(10.587f, 5.051f)
                lineTo(10.874f, 5.997f)
                lineTo(10.063f, 5.432f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.438f, 5.36f)
                lineTo(3.762f, 5.83f)
                lineTo(4f, 5.042f)
                lineTo(3.344f, 4.545f)
                lineTo(4.167f, 4.528f)
                lineTo(4.438f, 3.75f)
                lineTo(4.708f, 4.528f)
                lineTo(5.531f, 4.545f)
                lineTo(4.875f, 5.042f)
                lineTo(5.113f, 5.83f)
                lineTo(4.438f, 5.36f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.688f, 5.36f)
                lineTo(15.012f, 5.83f)
                lineTo(15.25f, 5.042f)
                lineTo(14.594f, 4.545f)
                lineTo(15.417f, 4.528f)
                lineTo(15.688f, 3.75f)
                lineTo(15.958f, 4.528f)
                lineTo(16.781f, 4.545f)
                lineTo(16.125f, 5.042f)
                lineTo(16.364f, 5.83f)
                lineTo(15.688f, 5.36f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.063f, 2.36f)
                lineTo(9.387f, 2.83f)
                lineTo(9.625f, 2.042f)
                lineTo(8.969f, 1.545f)
                lineTo(9.792f, 1.528f)
                lineTo(10.063f, 0.75f)
                lineTo(10.333f, 1.528f)
                lineTo(11.156f, 1.545f)
                lineTo(10.5f, 2.042f)
                lineTo(10.738f, 2.83f)
                lineTo(10.063f, 2.36f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.063f, 8.985f)
                lineTo(9.387f, 9.455f)
                lineTo(9.625f, 8.667f)
                lineTo(8.969f, 8.17f)
                lineTo(9.792f, 8.153f)
                lineTo(10.063f, 7.375f)
                lineTo(10.333f, 8.153f)
                lineTo(11.156f, 8.17f)
                lineTo(10.5f, 8.667f)
                lineTo(10.738f, 9.455f)
                lineTo(10.063f, 8.985f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NiuePreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Niue,
            contentDescription = "Niue Flag"
        )
    }
}
